module.exports = __webpack_public_path__ + "fonts/3MCircularTT-BookItalic.7da5f2e3.otf";